import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { NoteType } from 'src/app/model/crm/note-type';

@Injectable({
  providedIn: 'root',
})
export class NoteTypeTableService extends BaseTableService<NoteType> {
  constructor() {
    super();
  }
}
